import { HashLink } from "../Utils/HashLink";


export class AdminMiniButton extends HashLink
{
    constructor(url: string, text: string = "")
    {
        super("🐓 " + text, url);
        
        this.Class("admin-button")
    }
}
